<script setup lang="ts" xmlns="http://www.w3.org/1999/html">
import type {
  loadedBrandPresetsType,
  LoadedTopModelsType,
  LoadedTopPresetsType,
} from '~/interfaces/api';
import { API } from '~/api/api';
import { useGlobalStore } from '~/stores/global';

const globalStore = useGlobalStore();
const adult = computed(() => globalStore.adult);
const loadCategoryItems = [
  {
    id: 2801,
    name: 'Мобильные телефоны',
    slug: 'mobilnye-telefony',
    full_name: 'Мобильные телефоны',
  },
  {
    id: 510401,
    name: 'Планшеты',
    slug: 'planshety',
    full_name: 'Планшеты',
  },
  {
    id: 510201,
    name: 'Ноутбуки',
    slug: 'noutbuki',
    full_name: 'Ноутбуки',
  },
  {
    id: 2102,
    name: 'Наушники ',
    slug: 'naushniki',
    full_name: 'Наушники ',
  },
  {
    id: 2815,
    name: 'Смарт-часы и браслеты',
    slug: 'smart-chasy-i-umnye-braslety',
    full_name: 'Смарт-часы и браслеты',
  },
  {
    id: 3914,
    name: 'Умные колонки',
    slug: 'umnye-kolonki',
    full_name: 'Умные колонки',
  },
  {
    id: 1713,
    name: 'Телевизоры',
    slug: 'televizory',
    full_name: 'Телевизоры',
  },
  {
    id: 3701,
    name: 'Цифровые фотоаппараты',
    slug: 'cifrovye-fotoapparaty',
    full_name: 'Цифровые фотоаппараты',
  },
];
const loadedBrandPresets = ref<loadedBrandPresetsType>({});
const loadedTopPresets = ref<LoadedTopPresetsType>({});
const loadedTopModels = ref<LoadedTopModelsType>({});
const getCatalogData = async () => {
  try {
    const itemsData = await Promise.all(
      loadCategoryItems.map(async (itemCategory) => {
        const result = {
          brandPresets: {},
          topPresets: {},
          models: {},
        };
        if (itemCategory) {
          const blocksResponse = await API.get(
            `/categories/${itemCategory.id}/blocks?region_id=${globalStore.region.id}&block=top_presets&block=brand_presets`
          );
          const blocksData = blocksResponse.data;
          if (blocksData) {
            if (blocksData.blocks && blocksData.blocks.length > 1) {
              result.brandPresets = {
                [itemCategory.id]: blocksData.blocks[1].items,
              };
              result.topPresets = {
                [itemCategory.id]: blocksData.blocks[0].items.slice(0, 40),
              };
            }
          }

          const modelsArrRes = await API.post(
            `/categories/${itemCategory.id}/list`,
            null,
            {
              params: {
                region_id: globalStore.region.id,
                page: 1,
                per_page: 10,
                adult: adult.value,
                sem: globalStore.sem || undefined,
                device: globalStore.device || 1,
              },
            }
          );
          const modelsArr = modelsArrRes.data;
          if (modelsArr && modelsArr.list && modelsArr.list.length) {
            result.models = { [itemCategory.id || 0]: modelsArr.list };
          }
          return { ...itemCategory, ...result };
        }
      })
    );
    const blocks = itemsData.reduce(
      (data, item) => {
        return {
          ...item,
          brandPresets: {
            ...(data?.brandPresets || {}),
            ...(item?.brandPresets || {}),
          },
          topPresets: {
            ...(data?.topPresets || {}),
            ...(item?.topPresets || {}),
          },
          models: { ...(data?.models || {}), ...(item?.models || {}) },
        };
      },
      { brandPresets: {}, topPresets: {}, models: {} }
    );
    return blocks;
  } catch (e) {
    // console.error('fetch error', e);
    return null;
  }
};
const asyncData = await useAsyncData('asyncCatalogCategoryData2', async () => {
  const data = await getCatalogData();
  return data;
});
if (asyncData.status.value) {
  const data = asyncData.data.value;
  if (data) {
    loadedBrandPresets.value = data?.brandPresets || {};
    loadedTopPresets.value = data?.topPresets || {};
    loadedTopModels.value = data?.models || {};
  }
}
</script>

<template>
  <ul class="l-container l-description-grid categories">
    <CatalogCategoryItem
      v-for="(item, index) in loadCategoryItems"
      :key="`${index}_category-item`"
      :item="item"
      :loaded-top-presets="loadedTopPresets"
      :loaded-brand-presets="loadedBrandPresets"
      :loaded-top-models="loadedTopModels"
      :page-data="loadCategoryItems"
      :no-more-button="true"
      title-class="heading-m"
    />
  </ul>
</template>

<style scoped lang="scss"></style>
